// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"d368fdd4","454":"ed6b34a0","456":"7342b9b9","475":"c354fd02","616":"363c8754","638":"77397df0"}[chunkId] + ".chunk.js";
};